import cookie from "react-cookies";
import * as qs from "query-string";

function makeid(length) {
  var result = "";
  var characters = "ABCDFGHIJKLMNOPQRSTUVWXYZabcdfghijklmnopqrstuvwxyz123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return `${result}_pg`;
} //Рандомизатор

export function deleteCoocies() {
  for (var key in cookie.loadAll()) {
    cookie.remove(key, { path: "/" });
  }
} // Удаление всех куки

export function DetectPartner(location) {
  const isOrderId = cookie.load("order_id");
  if (!isOrderId) {
    const order = makeid(13);
    cookie.save("order_id", order, {
      path: "/",
      maxAge: 30 * 24 * 60 * 60,
    });
    cookie.save("order", order, {
      path: "/",
      maxAge: 30 * 24 * 60 * 60,
    });
    cookie.save("unic_hit", makeid(15), {
      path: "/",
      maxAge: 30 * 24 * 60 * 60,
    });

    cookie.save("partnersURL", window.location.search, { path: "/" });
  }

  let locatoinUrl = qs.parse(location, { ignoreQueryPrefix: true });
  let partner = locatoinUrl.partner ? locatoinUrl.partner : null;

  if (partner) {
    cookie.save("partner", location, { path: "/", maxAge: 30 * 24 * 60 * 60 });
    Object.entries(locatoinUrl).forEach((el) => {
      cookie.save(el[0], el[1], { path: "/", maxAge: 30 * 24 * 60 * 60 });
    });
  }

  // cookie.save("total_url_info", location, {
  //   path: "/",
  //   maxAge: 30 * 24 * 60 * 60,
  // });
  // Object.entries(locatoinUrl).forEach((el) => {
  //   cookie.save(el[0], el[1], { path: "/", maxAge: 30 * 24 * 60 * 60 });
  // });
} // Выявление партнера



// WEBPACK FOOTER //
// src/detectPartnerUrl.js